/** @jsx h */
import { Fragment } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { $, $$ } from 'utils/dom';
import { $search, labels } from '../config';
import FilterFieldset from './FilterFieldset';
import DatePicker from './DatePicker';
import DatePickerFilter from './DatePickerFilter';
import { initFilterToggle } from '../../filter/filter';

const FilterContainer = ({
  facets,
  triggerAjaxSubmit,
  pluginNamespace,
  searchType,
}) => {
  const [datepickerFilter, setDatepickerFilter] = useState('');
  const [resetFn, setResetFn] = useState(null);

  const handleReset = () => {
    const checkboxes = $$('.search-section input[type="checkbox"]', $search);
    const buttons = $$('.checkbox[type="button"]', $search);

    // find related checkbox and uncheck it before submit the form
    if (checkboxes.length) {
      checkboxes.forEach(checkbox => (checkbox.checked = false));
    }

    if (buttons.length) {
      buttons.forEach(button => {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      });
    }

    const textfields = $$('input[type="text"]', $search);
    if (textfields.length) {
      textfields.forEach(textfield => (textfield.value = ''));
    }

    setResetFn(new Date());

    triggerAjaxSubmit();
  };

  function handleChange(formattedDate) {
    setDatepickerFilter(formattedDate);
  }

  useEffect(() => {
    const filter = $('.filter');
    filter && initFilterToggle(filter);
  }, []);

  return (
    <Fragment>
      <button
        class="filter__button"
        aria-expanded="false"
        type="button"
        id="acc-btn-688237973738"
        aria-controls="acc-tab-688237973738"
      >
        <h3 class="filter-title">{labels.faceting.narrowSearch}</h3>
        <i class="filter-icon" aria-hidden="true" />
        <span class="sr-only">{labels.faceting.openFilter}</span>
      </button>
      <div class="filter__panel" aria-hidden="true">
        <div class="filter__layout-top">
          <div class="filter__layout-left">
            <ul class="filter__checkbox">
              {facets.main &&
                facets.main.map(facet => (
                  <FilterFieldset
                    key={facet.label}
                    facet={facet}
                    triggerAjaxSubmit={triggerAjaxSubmit}
                    pluginNamespace={pluginNamespace}
                    searchType={searchType}
                  />
                ))}
            </ul>
          </div>

          {facets.right && (
            <div class="filter__layout-right">
              {facets.right.map(facet => {
                const isDatepicker = facet.type === 'dateRange';
                if (isDatepicker) {
                  return (
                    <div class="filter__datepicker" key={facet.name}>
                      <DatePicker
                        facet={facet}
                        triggerAjaxSubmit={triggerAjaxSubmit}
                        pluginNamespace={pluginNamespace}
                        datepickerFilter={datepickerFilter}
                        resetFn={resetFn}
                      />
                    </div>
                  );
                } else {
                  return '';
                }
              })}
              <DatePickerFilter
                handleChange={handleChange}
                pluginNamespace={pluginNamespace}
              />
            </div>
          )}
        </div>

        <div class="filter__layout-bottom">
          <div class="filter__reset">
            <button class="button-reset" onClick={handleReset} type="button">
              <i class="filter__reset-icon icon-reset" aria-hidden="true" />
              <span class="filter__reset-text link">
                {labels.faceting.removeAllFilters}
              </span>
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default FilterContainer;
